import axios from 'axios';

import { BASE_URL } from '../../const';
import { RequestsApi } from '../RequestsApi';

class MemoryApi extends RequestsApi {
    async getMemories(bucket) {
        const query = bucket ? `?bucket=${bucket}` : '';
        return await this.request(`/memory${query}`, 'get');
    }

    async updateMemory(memoryId, content) {
        return await this.request(`/memory/${memoryId}`, 'put', { content });
    }

    async deleteMemory(memoryId) {
        return await this.request(`/memory/${memoryId}`, 'delete');
    }

    async deleteAllMemories() {
        return await this.request('/memory', 'delete');
    }

    async toggleMemory(enabled) {
        return await this.request('/memory/toggle', 'put', { enabled });
    }

    async checkRegion() {
        const result = await axios.get(`${BASE_URL}/memory/region-check`);
        return result.data;
    }
}

export default new MemoryApi();
